import { apiClient } from "./authService";

// ================= REVENUE =================

export const getDailyRevenue = async (params?: {
  from?: string;
  to?: string;
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/daily-revenue", { params });
  return res.data;
};

// ================= EXPENSES =================

export const getExpensesDaily = async (params?: {
  from?: string;
  to?: string;
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/expenses/daily", { params });
  return res.data;
};

export const getExpensesByAccount = async (params?: {
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/expenses/by-account", { params });
  return res.data;
};

export const getExpensesSummary = async (params?: {
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/expenses/summary", { params });
  return res.data;
};

// ================= PROFIT & LOSS =================

export const getProfitAndLoss = async (params?: {
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/pnl", { params });
  return res.data;
};

// ================= BALANCE SHEET =================

export const getBalanceSheet = async (params?: {
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/balance-sheet", { params });
  return res.data;
};

// ================= LEDGER =================

export const getLedgerByAccount = async (params: {
  accountId: number;
  from?: string;
  to?: string;
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/ledger-by-account", { params });
  return res.data;
};

// ================= INVOICES =================

export const getUnpaidInvoices = async (params?: {
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/reports/unpaid-invoices", { params });
  return res.data;
};

export async function getCashflowReport({
  from,
  to,
  businessId,
  unitId,
  invoiceStatus,
  expensesPaid,
  page,
  size,
  search,
}: {
  from: string; 
  to: string;
  businessId?: string;
  unitId?: string;
  invoiceStatus?: string;
  expensesPaid?: boolean;
  page?: number;
  size?: number;
  /** Narrows the listed rows; the summary still covers the whole period. */
  search?: string;
}) {
  const res = await apiClient.get(`/reports/cashflow`, {
    params: {
      ...(search?.trim() ? { search: search.trim() } : {}),
      from,
      to,
      businessId,
      unitId,
      invoiceStatus,
      expensesPaid: typeof expensesPaid === "boolean" ? expensesPaid : true,
      page,
      size,
    },
  });

  return res.data;
}


//Refund :
export const getRefunds = async (params?: {
  from?: string;
  to?: string;
  businessId?: string;
  unitId?: string;
}) => {
  const res = await apiClient.get("/refunds", { params });
  return res.data;
};
